<div class="padding flex column">
	<b class="bold margin-bottom-small">Confirm order</b>

	<div class="flex column">
		<span class="padding-small bg-orange margin-bottom-small flex center">
			<i class="fa-solid fa-exclamation-triangle margin-right-smallest"></i>
			Are you sure you want to confirm this order?
		</span>

		<div class="padding-small border">
			<div class="flex center">
				<b class="margin-right-smallest">Photographer:</b>
				{{ data.order.photographer?.fullName }}
			</div>
			<div class="flex center">
				<b class="margin-right-smallest">Due date:</b>
				{{ data.order.dueDate | date: 'dd/MM/yyyy' }}
			</div>

			<div class="flex center">
				<b class="margin-right-smallest">Notes:</b>
				{{ data.order.notes || '-' }}
			</div>

			<b>Products:</b>

			@if (!loading) {
				<div class="margin-top-small scrollable fix-width fix-height">
					<!-- color table-->
					<table>
						@for (style of styles; track style.modelId) {
							@for (color of style.colors; track color.id) {
								<tr>
									<td>{{ style.brand.name }} - {{ style.category.name }} - {{ style.modelId }} - {{ color.name }} - {{ color.size?.name }} - EAN: {{ color.size?.ean }}</td>
								</tr>
							}
						}
					</table>
				</div>
			}

			@if (loading) {
				<div class="margin-top-small fix-width fix-height flex center justify-center bg-light-grey"></div>
			}
		</div>
	</div>

	<div class="flex column end margin-top">
		<div class="flex center">
			<button (click)="close()" class="stroked margin-right-small">
				<i class="fa-solid fa-undo"></i>
				Discard
			</button>

			<button (click)="confirm()">
				<i class="fa-solid fa-check"></i>
				Confirm
			</button>
		</div>
	</div>
</div>

@if (loading) {
	<bt-loader></bt-loader>
}
